import "styles/termsConditions.less";

import React, { useEffect, useState } from "react";

import { Col } from "antd";
import ReactMarkdown from "react-markdown";

import { UK_ROUTES } from "../../../constants/routes";
import { ITermsAndConditions } from "../../../types/termsAndConditions";
import { logError } from "../../../utils/sentry";
import Layout from "../../basic/Layout";
import Navigation from "../../basic/Navigation/Navigation";

const TermsConditions: React.FC = () => {
    const [termsAndConditions, setTermsAndConditions] = useState<ITermsAndConditions | undefined>();
    useEffect(() => {
        const handleResponse = async () => {
            try {
                const contentful = require("contentful");
                const client = contentful.createClient({
                    space: "w0hcz4e46cwo",
                    accessToken: "OEsI882KvnNdRBQ5iQXclL8wRzJZHD65Ah99KvmsPLg",
                });
                const response = await client.getEntries({
                    content_type: "termsAndConditionsUk",
                });

                return response.items[0];
            } catch (error: any) {
                const contextInfo = {
                    function: "retrieveTermsAndConditions",
                    error: error.message,
                };
                logError(error, contextInfo);
            }
        };
        handleResponse().then(response => setTermsAndConditions(response));
    }, [setTermsAndConditions]);
    return (
        <Layout>
            <Navigation items={[{
                title: "Home",
                url: UK_ROUTES.home,
            }, {
                title: "Terms and Conditions",
                url: UK_ROUTES.tcs,
            }]} />
            <Col className="terms-conditions__content">
                {termsAndConditions && <ReactMarkdown className="terms-conditions__text" children={termsAndConditions?.fields.body}/>}
            </Col></Layout>
    );
};

export default TermsConditions;
